
import  axios  from 'axios';
import {getSingleUser, loadSingleUserDataInStore} from "../user/actions";
import {loadCompanysDataWithUserId} from "../company";
import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore, loadTowjobDataInStore} from "../towjob/actions";
import AppUtils from "../../../utils/AppUtils";
import {loadStoragelotDataInStore} from "../storagelot/actions";


export const LOAD_TOWCOMPANYTRUCK_DATA = 'towcompanytruck/LOAD_TOWCOMPANYTRUCK_DATA';
export const DELETE_A_TOWCOMPANYTRUCK = 'towcompanytruck/DELETE_A_TOWCOMPANYTRUCK';
export const SAVE_A_TOWCOMPANYTRUCK = 'towcompanytruck/SAVE_A_TOWCOMPANYTRUCK';
export const UPDATE_A_TOWCOMPANYTRUCK = 'towcompanytruck/UPDATE_A_TOWCOMPANYTRUCK';
export const CLEAR_A_TOWCOMPANYTRUCK_ERROR_MESSAGE = 'towcompanytruck/CLEAR_A_TOWCOMPANYTRUCK_ERROR_MESSAGE';


export function clearTowCompanyTruckErrorMsgInStore(){
    return {
        type: CLEAR_A_TOWCOMPANYTRUCK_ERROR_MESSAGE,
        
    }
}

export function loadTowCompanyTruckDataInStore(argTowCompanyTruckDataArray) {
    return {
        type: LOAD_TOWCOMPANYTRUCK_DATA,
        towcompanytrucksData:argTowCompanyTruckDataArray
    }
}
export function deleteATowCompanyTruckInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_TOWCOMPANYTRUCK,
        deleteTowCompanyTruckResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveATowCompanyTruckDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_TOWCOMPANYTRUCK,
        saveTowCompanyTruckResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateATowCompanyTruckDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_TOWCOMPANYTRUCK,
        updateTowCompanyTruckResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

/********************* End of InStore calls **************************/


export function addTruckToTrucksArray(argTruck ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempTruckArray=[] ;
        tempTruckArray = Object.assign(tempTruckArray,state.towcompanytruck.towcompanytrucksArray);
        
        //first remove the item if it's in the list
        let newTrucksArray = tempTruckArray.filter(element => { return element.id !== argTruck.id });
        //adding to the top of the array.
        newTrucksArray.unshift(argTruck);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadTowCompanyTruckDataInStore(newTrucksArray));
    }//end of return
}


export function deleteTruckFromTrucksArray(argTruckId ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempTruckArray=[] ;
        tempTruckArray = Object.assign(tempTruckArray,state.towcompanytruck.towcompanytrucksArray);
        //removig the match element with the matching id.
        let newArray = tempTruckArray.filter(element => { return element.id != argTruckId });
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadTowCompanyTruckDataInStore(newArray));
    }//end of return
}

export function updateTruckInTrucksArray(argTruck ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempTruckArray=[] ;
        tempTruckArray = Object.assign(tempTruckArray,state.towcompanytruck.towcompanytrucksArray);//storagelot.storagelotsArray);
        //rempoving the item from the array and then add the updated one to the array array.
        let newArray = tempTruckArray.filter(element => { return element.id != argTruck.id });
        //adding to the top of the array.
        newArray.unshift(argTruck);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadTowCompanyTruckDataInStore(newArray));
    }//end of return
}


//****************************************
//Below is for update a Stream
//****************************************

export function clearTowCompanyTruckErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearTowCompanyTruckErrorMsgInStore());
    }
}

export function updateATowCompanyTruck(argURL, argCamera, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        updateATowCompanyTruckOnServer(argURL, argCamera, argCompanyId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(updateATowCompanyTruckDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));
            dispatch(loadTowCompanyTrucksData(argURL, argCompanyId));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error saving a towcompanytruck" + errorObj.statusText + errorObj.status);
            dispatch(updateATowCompanyTruckDataInStore({}, errorObj));
        });
    }//end of return
}


function updateATowCompanyTruckOnServer( argURL, argCamera, argCompanyId ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateATowCompanyTruck(argURL, argCamera, argCompanyId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a StorageLot " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateATowCompanyTruck(argURL, argTowCompanyTruck,argCompanyId ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towcompanytrucks" ;
    console.log(" on posting a towcompanytruck the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argTowCompanyTruck, {headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveATowCompanyTruck(argURL, argCamera,argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        saveATowCompanyTruckOnServer(argURL, argCamera,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveATowCompanyTruckDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));
            dispatch(loadTowCompanyTrucksData(argURL, argCompanyId));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
           console.log("I had an error saving a storage lot" + + errorObj.statusText + errorObj.status);
            dispatch(saveATowCompanyTruckDataInStore({}, errorObj));
        });
    }//end of return
}


function saveATowCompanyTruckOnServer( argURL, argCamera, argCompanyId  ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveATowCompanyTruck(argURL, argCamera, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a towcompanytruck " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveATowCompanyTruck(argURL, argCamera, argCompanyId ,argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towcompanytrucks";
    console.log(" on posting a towcompanytruck the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteATowCompanyTruck(argURL, argCameraId, argCompanyId ) {
    return (dispatch, getState) => {
        const state = getState();
        deleteATowCompanyTruckOnServer(argURL, argCameraId,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){
            //dispatch(loadTowCompanyTrucksData(argURL, argCompanyId));
            dispatch(deleteATowCompanyTruckInStore(deleteResponse.data, {"status":deleteResponse.status, "statusText":deleteResponse.statusText}));
            dispatch(loadTowCompanyTrucksData(argURL, argCameraId));
            
        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteATowCompanyTruckInStore({}, errorObj));
        });
    }//end of return
}


function deleteATowCompanyTruckOnServer( argURL, argStreamId,argCompanyId,  argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteATowCompanyTruck(argURL, argStreamId, argCompanyId , argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a TowCompanyTruck " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteATowCompanyTruck(argURL, argRealCompanyId, argStorageId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies"+"/"+argRealCompanyId+"/towcompanytrucks/"+argStorageId;
    console.log(" on deleteing a TowCompanyTruck the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of companys
/*
export function loadTowCompanyTrucksData(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfTowCompanyTrucks(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){

            dispatch(loadTowCompanyTruckDataInStore(companysList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
*/

export function loadTowCompanyTrucksData(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        
        if((state.user.saveUserResp == null) ||(state.user.saveUserResp.id == null) || (state.user.saveUserResp.id == undefined)) {
            getSingleUser(argURL, state.login.loginData.idToken).then(function(userData){
                
                // dispatch(loadTowjobDataInStore(companysList));
                dispatch(loadSingleUserDataInStore(userData));
                dispatch(loadCompanysDataWithUserId(argURL,userData.id ));
    
               //getListOfTowCompanyTrucks(argURL, state.company.selectedCompany, state.login.loginData.idToken, userData.id).then(function(companysList){
                    getListOfTowCompanyTrucks(argURL, argCompanyId, state.login.loginData.idToken, userData.id).then(function(companysList){
                    
                    dispatch(loadTowCompanyTruckDataInStore(companysList));
                    
                }, function(err){
                    console.log("I had an error gettting loadTowjobsData" + err);
                });
                
            }, function(err){
                console.log("I had an error gettting Farms Data2" + err);
            });
            
            
            
            
        }else{
            getListOfTowCompanyTrucks(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){
                
                dispatch(loadTowCompanyTruckDataInStore(companysList));
                
            }, function(err){
                console.log("I had an error gettting loadTowjobsData" + err);
            })};
    }//end of return
}



function getArrayOfGetsForListOfTowCompanyTrucks(argURL,argCompanyId ,argIdToken, argUserId  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towcompanytrucks";
    console.log(" on getting list of TowCompanyTrucks  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfTowCompanyTrucks( argURL, argCompanyId ,argIdToken, argUserId ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfTowCompanyTrucks(argURL, argCompanyId ,argIdToken, argUserId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}

